import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Tag } from 'antd';
import TooltipHelp from 'components/Tooltip/tooltipHelp';
import FormDetalheArquivoJustificativa from './arquivo';
import FormDetalheButtons from './buttons';
import { STATUS_REQUERIMENTO } from 'utils/consts';
import { getColorStatus, montaNomeAtendente } from 'utils/funcaoPadrao';
import { valueOrDefaultValue } from 'utils/formUtils';
import * as S from './styles';
import * as Style from 'components/Style';
import FormDetalheDadosCadastrais from 'containers/DetalheDadosCadastrais';

export default function FormPadraoDetalhe({ dados }) {
  return (
    <S.Contain>
      <Style.GlobalCard>
        <Row justify={'space-between'}>
          <Col lg={6} md={8} sm={12}>
            <S.ContainerLabelValorTitulo>
              <S.Label fontSize={'15pt'}>Localizador:</S.Label>
              <S.ValorDestaque>{dados?.localizador}</S.ValorDestaque>
            </S.ContainerLabelValorTitulo>
          </Col>
          <Col xl={6} md={8} sm={12}>
            <S.ContainerLabelValorTitulo>
              <Row>
                <Col span={24} style={{ display: 'flex' }}>
                  <S.Label fontSize={'15pt'}>Status:</S.Label>
                  <S.ValorDestaque marginTop={'-1px'}>
                    <Tag {...getColorStatus(dados?.status?.id)} style={{ fontSize: '13pt' }}>
                      {dados?.status?.descricao.toUpperCase()}
                    </Tag>
                  </S.ValorDestaque>
                </Col>
                <Col span={24} style={{ display: 'flex' }}>
                  {dados?.status?.id === STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.id && (
                    <>
                      <S.Label fontSize={'12pt'}>Atendente que encaminhou: </S.Label>
                      <S.ValorDestaque fontSize={'12pt'}>
                        {dados?.ultimoAtendenteQueEncaminhou &&
                          montaNomeAtendente(valueOrDefaultValue(dados?.ultimoAtendenteQueEncaminhou?.nome, ''))}
                      </S.ValorDestaque>
                    </>
                  )}
                </Col>
              </Row>
            </S.ContainerLabelValorTitulo>
          </Col>
          <Col xl={8} md={8} sm={12}>
            <S.ContainerLabelValorTitulo>
              <Row>
                <Col span={24} style={{ display: 'flex' }}>
                  <S.Label fontSize={'15pt'}>Serviço:</S.Label>
                  <S.ValorDestaque>{dados?.servico}</S.ValorDestaque>
                </Col>
                <Col span={24}>
                  {dados?.status?.id === STATUS_REQUERIMENTO.ENCAMINHADO_ATENDENTE.id && (
                    <>
                      <div style={{ display: 'flex' }}>
                        <S.Label fontSize={'12pt'}>De setor: </S.Label>
                        <S.ValorDestaque fontSize={'12pt'}>
                          {valueOrDefaultValue(dados?.setorOrigem?.nome, ' - - ')}
                        </S.ValorDestaque>
                      </div>
                      <div style={{ display: 'flex' }}>
                        <S.Label fontSize={'12pt'}> Para setor: </S.Label>
                        <S.ValorDestaque fontSize={'12pt'}>
                          {valueOrDefaultValue(dados?.setorDestino?.nome, ' - ')}
                        </S.ValorDestaque>
                      </div>
                    </>
                  )}
                </Col>
              </Row>
            </S.ContainerLabelValorTitulo>
          </Col>
          {dados?.solicitacao?.nome && (
            <Col xl={6} md={12} sm={12}>
              <S.ContainerLabelValorTitulo>
                <TooltipHelp
                  text={
                    <div
                      dangerouslySetInnerHTML={{ __html: dados?.solicitacao?.documentos }}
                      style={{
                        color: 'var(--white-color-sefaz)',
                        paddingLeft: dados?.solicitacao?.documentos.includes('<li>') ? '20px' : 0,
                      }}
                    />
                  }
                />
                <S.Label>Solicitação:</S.Label>

                <S.Valor marginTop={'3px'}>{dados?.solicitacao?.nome}</S.Valor>
              </S.ContainerLabelValorTitulo>
            </Col>
          )}
        </Row>
        <S.Titulo>Dados Pessoais</S.Titulo>
        <FormDetalheDadosCadastrais dados={dados} endereco={dados} />
        <S.Titulo marginTop={'50px'}>Arquivo e Justificativa</S.Titulo>
        <FormDetalheArquivoJustificativa dados={dados} />
        <FormDetalheButtons dados={dados} />
      </Style.GlobalCard>
    </S.Contain>
  );
}
FormPadraoDetalhe.propTypes = {
  dados: PropTypes.object,
};
